import RepairCreate from "./RepairCreate";
import RepairList from "./RepairList";
import RepairUpdate from "./RepairUpdate";

export default {
  RepairCreate,
  RepairList,
  RepairUpdate,
};
